import React from "react";
import PropTypes from "prop-types";

import "./styles.styl";

export default function LabeledPrice(props) {
  let { label, price, incl, symbol = "€" } = props;
  return (
    <span className="labeled-price">
      <span className="labeled-price__label">{label}</span>
      <span className="labeled-price__price">
        {price} {symbol}
      </span>
    </span>
  );
}

LabeledPrice.propTypes = {
  label: PropTypes.string,
  price: PropTypes.any,
};
